import { postRequest } from '../../../../helpers/apiClient';
import { useMutationWithLogout } from 'js/hooks/useMutationWithLogout';
import apiRoutes from '../../../../api-routes';

export const useAddPrivateNotificationTemplateGroup = (options) =>
  useMutationWithLogout(async ({ data }) => {
    const { data: createData } = await postRequest({
      url: apiRoutes.PRIVATE_NOTIFICATION_TEMPLATE_GROUPS,
      data,
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });

    return createData;
  }, options);
